module.exports = __webpack_public_path__ + "img/logo_3.1792f1bf.png";